

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CourseListResponse, getCourses } from "../../../../api/courses";

interface UseCoursesListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
  type?: string
}

export const useCourseList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
  type = 'Course'
}: UseCoursesListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit] = useState(initialLimit);

  const responseQuery = useQuery<CourseListResponse>({
    queryKey: ["admin-courses", { page, limit }],
    queryFn: () => getCourses({ page, limit, ...(type === 'all' ? {} : { type }) }, isAdmin),
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
  };

  return {
    ...responseQuery,
    page,
    limit,
    onPaginationChange,
  };
};